module.exports = __webpack_public_path__ + "media/src/images/course-page-card_image_inline-cb792fa6efacbe0eb023037d133943ec.png";